import React, { useState, useEffect } from 'react';
import styles from './S1.module.css';
import defaultVideo from './images/brazo.mp4';
import logohorizontal from './images/LogoHorizontal.png';

const titles = ["Bases de Datos", "Inteligencia Artificial", "Analítica Predictiva", "Comportamiento Humano"];

const Seccion1 = () => {
  const [currentTitleIndex, setCurrentTitleIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTitleIndex(prevIndex => (prevIndex + 1) % titles.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  // No permitir el scroll horizontal, bloquear
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
  }, []);

  return (
    <div className={styles.container}>
      <video autoPlay playsInline loop muted className={styles.backgroundVideo}>
        <source src={defaultVideo} type="video/mp4" />
      </video>
      <img src={logohorizontal} alt="Logo" className={styles.overlayImage} />
      <p className={styles.overlayText}>{titles[currentTitleIndex]}</p>
    </div>
  );
};

export default Seccion1;
